import mapboxgl from 'mapbox-gl';

import { MAPBOX_API_KEY } from '../constants';

mapboxgl.accessToken = MAPBOX_API_KEY;

export const createMap = (container, lat, lng, params) => {
  const map = new mapboxgl.Map({
    style: 'mapbox://styles/exr/clt3hoxwz00o701qw2ymbdk7n',
    container: container,
    center: [lat, lng],
    ...params,
  });

  map.addControl(
    new mapboxgl.NavigationControl({
      showCompass: false,
    })
  );

  map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: false,
      showAccuracyCircle: false,
    })
  );
  return map;
};

export const renderSubways = (map) => {
  let hoveredStopId = null;

  map.addSource('subway-lines', {
    type: 'geojson',
    data: '/geojson/subway_lines.geojson',
  });

  map.addSource('subway-stops', {
    type: 'geojson',
    data: '/geojson/subway_stops.geojson',
  });

  map.addLayer({
    id: 'subway-lines',
    type: 'line',
    source: 'subway-lines',
    layout: {},
    paint: {
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 1, 14, 4],
      'line-color': ['get', 'color'],
    },
  });

  map.addLayer({
    id: 'subway-stops',
    type: 'circle',
    source: 'subway-stops',
    paint: {
      'circle-color': ['get', 'color'],
      'circle-radius': ['interpolate', ['linear'], ['zoom'], 12, 2, 14, 10],
      'circle-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0.5],
    },
  });

  map.on('mousemove', 'subway-stops', (e) => {
    if (e.features.length > 0) {
      if (hoveredStopId) {
        map.setFeatureState({ source: 'subway-stops', id: hoveredStopId }, { hover: false });
      }

      hoveredStopId = e.features[0].id;

      map.setFeatureState({ source: 'subway-stops', id: hoveredStopId }, { hover: true });
    }
  });

  map.on('mouseleave', 'subway-stops', (e) => {
    if (hoveredStopId) {
      map.setFeatureState({ source: 'subway-stops', id: hoveredStopId }, { hover: false });
    }

    hoveredStopId = null;
  });

  map.on('click', 'subway-stops', (e) => {
    let feature = e.features[0];
    let coordinates = feature.geometry.coordinates.slice();
    let lines = JSON.parse(feature.properties.lines);

    lines = lines.reduce((acc, line) => {
      var html = `<div class="mr-2 lg:mr-2 w-6 h-6 rounded-full flex items-center justify-center text-white font-bold" style="background-color: ${line.color}">${line.line}</div>`;

      return `${acc}${html}`;
    }, '');

    let html = `<div class="pr-2 z-20"><h1 class="text-normal font-bold mb-2">${feature.properties.name}</h1><div class="flex">${lines}</div></div>`;

    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(map);
  });
};
